export const getPostponeViewAction = "MEMEBER_SERVICE/VIEW/POSTPONE";
export const getPostponeViewSuccessAction = "MEMEBER_SERVICE/VIEW/POSTPONE/SUCCESS";
export const getPostponeViewFailAction = "MEMEBER_SERVICE/VIEW/POSTPONE/FAIL";
export const getPostponeViewResetAction = "MEMEBER_SERVICE/VIEW/POSTPONE/RESET";
